import { Outlet } from "react-router-dom";

export default function AuthContainer() {
    return (
        <div>
            <Outlet />
        </div>
    )
}